import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private apiUrl: string;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.apiUrl = `${this.appConfigService.server.url}/send-contact-email`;
  }

  sendContactForm(formData: { name: string; email: string; message: string }): Observable<any> {
    return this.http.post(this.apiUrl, formData);
  }
}